import layout from '@/views/layout/layout.vue'
const productCategoryList = r => require.ensure([], () => r(require('@/views/ywt/productCategory/list.vue')), 'group-ywt-productCategory')

const ywtProductCategory = [
  {
    path: '/ywt/productCategory',
    name: 'ywt-productCategory',
    component: layout,
    redirect: '/ywt/productCategory/list',
    children: [
      {
        path: 'list',
        name: 'ywt-productCategory-list',
        component: productCategoryList,
        meta: {
          displayName: '产品分类管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default ywtProductCategory



// WEBPACK FOOTER //
// ./src/router/ywt/productCategory.js